<mat-toolbar [ngClass]="{ mobile: (isMobile$ | async) === true }">
  <wm-libs-logo [app]="app" [env]="env" [isDarkMode]="isDarkMode$ | async"></wm-libs-logo>

  <wm-libs-nav-items *ngIf="(isMobile$ | async) === false && isAuth && !accessToken" [env]="env" [app]="app" [isAuth]="isAuth"></wm-libs-nav-items>

  <span class="spacer"></span>

  <div *ngIf="accessToken && accessTokenPermissions?.length && (isMobile$ | async) === false">
    <span class="bold"> {{ 'WM_TECH_POOL.ACCESSTOKEN.PERMISSIONS' | translate }}:&nbsp;</span>

    <span *ngFor="let permission of accessTokenPermissions; let last = last">
      <span>{{ 'WM_TECH_POOL.ACCESSTOKEN.PERMISSIONS.' + permission | uppercase | translate }}</span>
      <span *ngIf="!last">,&nbsp;</span>
    </span>
  </div>

  <wm-libs-balance-block *ngIf="(isMobile$ | async) === false && app === 'wm-tech-pool' && balance && ((isAuth && !accessToken) || accessToken)" [balance]="balance"></wm-libs-balance-block>

  <wm-libs-nav-items *ngIf="(isMobile$ | async) === false && !isAuth && !accessToken" [env]="env" [app]="app" [isAuth]="isAuth"></wm-libs-nav-items>

  <div *ngIf="!isAuth && !accessToken" class="menu-line"></div>

  <wm-libs-toggle-theme></wm-libs-toggle-theme>

  <div *ngIf="!accessToken" class="menu-line"></div>

  <wm-libs-auth-buttons *ngIf="(isMobile$ | async) === false && !accessToken" [isAuth]="isAuth" [app]="app" [isDarkMode]="isDarkMode$ | async"> </wm-libs-auth-buttons>

  <button *ngIf="(isMobile$ | async) && !accessToken" class="burger" mat-icon-button onclick="this.blur()" (click)="toggleMenu()">
    <mat-icon>menu</mat-icon>
  </button>
</mat-toolbar>
